// Jeden wspólny zegar (co 1 s) dla bieżących czasów na liście wyników. Odświeżają się tylko komponenty,
// które go czytają (czas zawodników w trasie, stan w nagłówku), a nie cała tabela — dawny ResultsView
// przerysowywał co sekundę wszystkie wiersze.
import { ref, onMounted, onBeforeUnmount } from 'vue'

export const nowTick = ref(Date.now())
let timer = null
let users = 0

function start() {
  if (timer) return
  nowTick.value = Date.now()
  timer = setInterval(() => { nowTick.value = Date.now() }, 1000)
}

function stop() {
  if (timer) clearInterval(timer)
  timer = null
}

// W komponencie: const now = useNowTick() — zegar działa, dopóki ktoś go używa.
export function useNowTick() {
  onMounted(() => {
    users += 1
    start()
  })
  onBeforeUnmount(() => {
    users -= 1
    if (users <= 0) {
      users = 0
      stop()
    }
  })
  return nowTick
}
